var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"imageCustomFullPage"},[_c('router-link',{attrs:{"to":"/designportal"}},[_c('img',{attrs:{"src":"img/assets/logos/PortalBG_SM_Blank.png"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }